import {nextTick, reactive} from "vue";
import {LayoutSections} from "@/types/catalog-store";

export function useLayoutSections(
    loadedLayoutSections: LayoutSections,
) {
    const layoutSections: LayoutSections = reactive(loadedLayoutSections);

    function initializeTmplComponents() {
        // Musí proběhnout až po dalším překreslení, funkce přistupují k DOMu a dokud není vykreslen, tak by se operace provedla nad starým DOMem a to nechceme
        nextTick(() => {
            Templating.initVueComponents();
            Component.initComponents();
        });
    }

    return {
        layoutSections,
        initializeTmplComponents,
    }
}